import { useState } from "react";
import { AuthCheckbox } from "../components/AuthCheckbox";
import { Link, useLocation, useNavigate, Navigate } from "react-router-dom";
import { useAuth, formatApiError } from "../auth/AuthContext";
import GoogleAuthButton from "../components/GoogleAuthButton";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [remember, setRemember] = useState(true);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (user && user !== false) {
    const target = loc.state?.from || "/workspace";
    return <Navigate to={target} replace />;
  }

  const submit = async e => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await login(email.trim().toLowerCase(), password, remember);
      nav(loc.state?.from || "/workspace", { replace: true });
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || e2.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-shell" data-testid="login-page">
      <div className="auth-card">
        <Link to="/" className="auth-brand" data-testid="auth-brand-link">
          <img src="/logo.png" alt="GoPrintPack" className="auth-logo"/>
        </Link>
        <h1>Welcome back</h1>
        <p className="auth-sub">Log in to your workspace to post RFQs, review sealed bids, or manage your production profile.</p>

        <GoogleAuthButton testId="login-google-btn" />
        <div className="auth-divider" data-testid="auth-divider"><span>or sign in with email</span></div>

        <form onSubmit={submit} className="auth-form">
          <label>Email
            <input
              data-testid="login-email"
              type="email"
              autoComplete="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="you@company.com"
              required
            />
          </label>
          <label>Password
            <input
              data-testid="login-password"
              type={showPw ? "text" : "password"}
              autoComplete="current-password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </label>
          <AuthCheckbox testid="login-show-password" checked={showPw} onChange={setShowPw} label="Show password"/>
          <AuthCheckbox testid="login-remember" checked={remember} onChange={setRemember} label="Keep me signed in"/>
          {err && <div className="auth-error" data-testid="login-error">{err}</div>}
          <button data-testid="login-submit" className="primary-btn full" disabled={busy}>
            {busy ? "Signing in…" : "Sign in"}
          </button>
          <div className="auth-forgot">
            <Link to="/forgot-password" data-testid="forgot-password-link">Forgot password?</Link>
          </div>
        </form>

        <div className="auth-alt">
          <span>New to GoPrintPack™?</span>
          <Link to="/register" data-testid="go-register">Create an account →</Link>
        </div>

      </div>
    </div>
  );
}
